import React, { createContext, useContext, useState } from 'react';

const themes = {
  instant: {
    pick3: {
      themeName: 'pick 3',
      selectedNumbers: 30,
      background: 'linear-gradient(to top, #1A0033 0%, #A445FF 100%)',
      backgroundInside: 'rgba(30, 0, 50, 0.4)',
      backgroundTicket: '#726DA8AA',
      border: '2px solid #E8CFFF',
      hoverColor: 'linear-gradient(to top, #25004D 0%, #B86EFF 100%)',
      btnsColor: '#9A42FF',
      textColor: '#9A42FF',
      ballsColor: 'linear-gradient(to top, #1A0033 0%, #A445FF 100%)',
      selectedColor: '#7A29CC',
      nightModeColor: 'white',
      howtoPlay: '0 to 9',
      pickedNumbers: 3,
      counterTime: 0.5,
    },
    lotto590: {
      themeName: 'lotto 5/90',
      selectedNumbers: 90,
      background:
        'linear-gradient(to top, rgb(0, 0, 0) 0%, rgb(50, 58, 45) 100%)',
      backgroundInside: 'rgb(39, 45, 35)',
      backgroundTicket: '#64714A66',
      border: '2px solid #FBE4F7',
      hoverColor: 'linear-gradient(270deg, #0B3E03 0%, #235B33 100%)',
      btnsColor: 'linear-gradient(270deg, #0B3E03 0%, #235B33 100%)',
      textColor: '#235B33',
      ballsColor: ' linear-gradient(270deg, #44DE78 0%, #0B3E03 100%)',
      selectedColor: '#01541d',
      nightModeColor: 'white',
      howtoPlay: '1 to 90',
      pickedNumbers: 5,
      counterTime: 0.5,
    },
  },
  loto: {
    themeName: 'lotto 4/48',
    selectedNumbers: 48,
    background: 'linear-gradient(270deg, #023E8A 0%, #0077B6 100%)',
    backgroundInside: 'rgb(20, 30, 50)',
    backgroundTicket: '#64714A66',
    border: '2px solid #FBE4F7',
    boxShadow: '0px 0px 4px 0px rgba(128, 251, 255, 0.87)',
    hoverColor: 'linear-gradient(270deg, #023E8A 0%, #0077B6 100%)',
    btnsColor: 'linear-gradient(270deg, #023E8A 0%, #0077B6 100%)',
    textColor: '#0077B6',
    ballsColor: 'linear-gradient(270deg, #44DEDE 0%, #023E8A 100%)',
    selectedColor: '#3A597A',
    nightModeColor: 'white',
    howtoPlay: '1 to 48',
    pickedNumbers: 4,
    counterTime: 0.5,
  },
  poolLotto: {
    themeName: 'Lotto 6/49',
    selectedNumbers: 49,
    background: 'linear-gradient(270deg, #4B0082 0%, #800080 100%)',
    backgroundInside: 'rgb(30, 15, 50)',
    backgroundTicket: '#64714A66',
    border: '2px solid #FBE4F7',
    boxShadow: '0px 0px 4px 0px rgba(77, 107, 254, 0.87)',
    hoverColor: 'linear-gradient(270deg, #4B0082 0%, #800080 100%)',
    btnsColor: 'linear-gradient(270deg, #4B0082 0%, #800080 100%)',
    textColor: '#800080',
    ballsColor: 'linear-gradient(270deg, #D144DE 0%, #4B0082 100%)',
    selectedColor: '#5A3E7A',
    nightModeColor: 'white',
    howtoPlay: '1 to 49',
    pickedNumbers: 6,
    counterTime: 0.5,
  },
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(themes.instant.lotto590);

  const switchTheme = (newTheme) => {
    const themeKeys = newTheme.split('.');
    let newThemeObj = themes;

    // Traverse the theme object based on the keys
    themeKeys.forEach((key) => {
      newThemeObj = newThemeObj[key];
    });
    setTheme(newThemeObj);
  };

  return (
    <ThemeContext.Provider value={{ theme, switchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  return useContext(ThemeContext);
};
